import * as CONST from "./actionTypes";

export const documentCategoryList = (payload, callBack) => {
  return {
    type: CONST.DOCUMENT_CATEGORY_LIST,
    payload: payload,
    callBack,
  };
};

export const documentCategoryList_Success = (payload) => ({
  type: CONST.DOCUMENT_CATEGORY_LIST_SUCCESS,
  payload,
});

export const documentCategoryList_Fail = (payload) => ({
  type: CONST.DOCUMENT_CATEGORY_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/
export const editDocumentCategory = (payload, callBack) => {
  return {
    type: CONST.EDIT_DOCUMENT_CATEGORY,
    payload: payload,
    callBack,
  };
};

export const editDocumentCategory_Success = (payload) => ({
  type: CONST.EDIT_DOCUMENT_CATEGORY_SUCCESS,
  payload,
});

export const editDocumentCategory_Fail = (payload) => ({
  type: CONST.EDIT_DOCUMENT_CATEGORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE USER >>>>>>>>>>>>>>>*/

export const updateDocumentCategory = (payload, callBack) => {
  return {
    type: CONST.UPDATE_DOCUMENT_CATEGORY,
    payload: payload,
    callBack,
  };
};

export const updateDocumentCategory_Success = (payload) => ({
  type: CONST.UPDATE_DOCUMENT_CATEGORY_SUCCESS,
  payload,
});

export const updateDocumentCategory_Fail = (payload) => ({
  type: CONST.UPDATE_DOCUMENT_CATEGORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD USER >>>>>>>>>>>>>>>*/

export const addDocumentCategory = (payload, callBack) => {
  return {
    type: CONST.ADD_DOCUMENT_CATEGORY,
    payload: payload,
    callBack,
  };
};

export const addDocumentCategory_Success = (payload) => ({
  type: CONST.ADD_DOCUMENT_CATEGORY_SUCCESS,
  payload,
});

export const addDocumentCategory_Fail = (payload) => ({
  type: CONST.ADD_DOCUMENT_CATEGORY_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/

export const deleteDocumentCategory = (payload, callBack) => {
  return {
    type: CONST.DELETE_DOCUMENT_CATEGORY,
    payload: payload,
    callBack,
  };
};

export const deleteDocumentCategory_Success = (payload) => ({
  type: CONST.DELETE_DOCUMENT_CATEGORY_SUCCESS,
  payload,
});

export const deleteDocumentCategory_Fail = (payload) => ({
  type: CONST.DELETE_DOCUMENT_CATEGORY_FAIL,
  payload,
});
